import { useEffect, useState } from "react";
import { PaginationProps } from "../../layouts/pagination/pagination.types";

const MAX_VISIBLE_BUTTONS = 6;

export const usePagination = ({
  page,
  count,
}: Pick<PaginationProps, "page" | "count">) => {
  const [pages, setPages] = useState<number[]>([]);

  const getChevronIconColor = (chevron: "Next" | "Previous") => {
    if (page === 1 && chevron === "Previous") {
      return true;
    }
    if (page === pages.length && chevron === "Next") {
      return true;
    }
    return false;
  };

  const countPages = () => {
    const aux = [];
    for (let i = 1; i < count + 1; i++) {
      aux.push(i);
    }
    setPages(aux);
  };

  useEffect(() => {
    countPages();
  }, [count]);

  return {
    getChevronIconColor,
    pages,
    maxVisibleButtons: MAX_VISIBLE_BUTTONS,
  };
};
